<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        class="pa-4"
        cols="3">
        <v-row
          class="white elevation-3 rounded"
          style="min-height: calc(100vh - 80px);">
          <v-col cols="12">
            <side-bar
              :prototypes="prototypes"
              :fetching-prototype="gettingPrototype"
              @add-prototype="addPrototypeToSelected($event)"
              @search="getPrototypes($event)" />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="9"
        class="pa-4"
      >
        <v-row
          style="min-height: calc(100vh - 80px);">
          <v-col
            cols="12">
            <div class="d-flex flex-row elevation-1 align-right white rounded pa-4">
              <h2>Print Fabric Label</h2>
              <v-spacer></v-spacer>
              <v-btn
                class="mr-2"
                color="secondary"
                text
                @click="downloadCsvTemplate()">
                <v-icon
                  class="mr-2"
                  right
                  dark
                  color="green"
                >
                  mdi-file-download-outline
                </v-icon>
                TEMPLATE
              </v-btn>
              <v-btn
                outlined
                class="mr-2"
                color="secondary"
                :loading="importing"
                :disabled="importing || exporting"
                @click="dialogImport = true">
                IMPORT FILE
              </v-btn>
              <v-dialog
                v-model="dialogImport"
                max-width="500px"
                @click:outside="onCloseCsvDialog">
                <v-card>
                  <v-card-title>Upload a File</v-card-title>

                  <v-card-text class="pb-0">
                    <p>คำเตือนเมื่อทำการเลือกไฟล์และคอนเฟิร์มรายการที่เลือกไว้ก่อนหน้าจะหายไป</p>
                    <v-file-input
                      v-model="selectedFile"
                      label="Select CSV file"
                      accept=".csv"
                      color="secondary"
                      class="my-2"
                      outlined
                      dense
                      hide-details
                      @focus="clearValidate"
                      @change="validateCsv" />
                    <p
                      v-if="csvValidateErrors.length"
                      class="text-bold">
                      Total {{ csvValidateErrors.length }} errors.
                    </p>
                    <div
                      v-if="csvValidateErrors.length"
                      class="csv-fail">
                      <p
                        v-for="(errText, index) in csvValidateErrors"
                        :key="index"
                        class="red--text">
                        {{ errText }}
                      </p>
                    </div>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      @click="onCloseCsvDialog">
                      Close
                    </v-btn>
                    <v-btn
                      color="secondary"
                      :disabled="csvValidateErrors.length > 0"
                      @click="addProductFromCsv">
                      Confirm
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <v-card
              v-if="prototypeNotFounds.length"
              class="white rounded mt-8 pa-4">
              <p
                class="text-bold red--text">
                ไม่มีในระบบ {{ prototypeNotFounds.length }}
              </p>
              <v-card
                class="pa-2"
                max-height="100"
                style="overflow: scroll;"
                outlined
                shaped
                tile>
                <p
                  v-for="(skuNotFound, index) in prototypeNotFounds"
                  :key="index"
                  class="mb-2">
                  <span class="text-bold">{{ index+1 }}.</span> {{ skuNotFound.sketchid }}
                  <span class="text-bold">สี</span> : {{ skuNotFound.color }}
                  <span class="text-bold">จำนวน</span> : {{ skuNotFound.qty }}
                </p>
              </v-card>
            </v-card>
            <v-card
              v-if="prototypeNotRequires.length"
              class="my-8 pa-4">
              <p class="font-bold text-h6 mb-0">
                สินค้าที่ไม่ต้องปรินท์ Fabric label
              </p>
              <div
                class="d-flex flex-column">
                <div
                  v-for="(p, i) in prototypeNotRequires"
                  :key="`no-print-${i}`">
                  <v-divider class="my-4"></v-divider>
                  <ItemBox
                    :hide-compositions="true"
                    :hide-input="true"
                    v-bind="p"
                    @remove-item="removePrototypeNotRequire(i)" />
                </div>
              </div>
            </v-card>
            <div
              v-if="noFabrics.length > 0"
              class="d-flex flex-column pa-4 white mt-4 rounded">
              <div class="d-flex justify-space-between align-center mb-2">
                <p class="text-h6 red--text mb-0">
                  รายการสินค้าที่ Fabric ไม่สมบูรณ์
                  <span class="text-caption red--text">(กรุณา export file ให้ merchandiser)</span>
                </p>
                <v-btn
                  color="success"
                  outlined
                  @click="exportNoFabric">
                  EXPORT
                </v-btn>
              </div>
              <v-divider class="mb-4"></v-divider>
              <div
                v-for="(p, i) in noFabrics"
                :key="`selected-${i}`">
                <v-divider
                  v-if="i !== 0"
                  class="my-4"></v-divider>
                <ItemBox
                  v-bind="p"
                  :qty.sync="p.qty"
                  @showExample="showExample"
                  @remove-item="removeItem(p.sketchId, p.color)" />
              </div>
            </div>
            <div
              v-if="hasFabrics.length > 0"
              class="d-flex flex-column pa-4 white mt-4 rounded">
              <div class="d-flex justify-space-between align-center mb-2">
                <p class="text-h6  mb-0">
                  รายการสินค้าที่มี Fabric compositions แล้ว
                </p>
                <v-btn
                  color="success"
                  :loading="exporting"
                  :disabled="!selectedPrototype.length"
                  @click="exportCsv()">
                  EXPORT
                </v-btn>
              </div>
              <v-divider class="mb-4"></v-divider>
              <div
                v-for="(p, i) in hasFabrics"
                :key="`selected-${i}`">
                <v-divider
                  v-if="i !== 0"
                  class="my-4"></v-divider>
                <ItemBox
                  v-bind="p"
                  :qty.sync="p.qty"
                  @showExample="showExample"
                  @remove-item="removeItem(p.sketchId, p.color)" />
              </div>
            </div>
            <v-dialog
              v-model="dialogFabric"
              max-width="400"
              transition="dialog-top-transition">
              <template #default>
                <v-card>
                  <v-toolbar
                    color="secondary"
                    dark>
                    ตัวอย่าง (จำนวนบรรทัดสูงสุด 11 บรรทัด)
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      @click="dialogFabric = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <div class="d-flex justify-center align-center pa-4">
                    <v-card
                      elevation="0"
                      class="text-center"
                    >
                      <Example
                        :fabric-compositions="exampleFabric.fabrics"
                        :sketch-id="exampleFabric.sketchId" />
                    </v-card>
                  </div>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PrototypeProvider from '@/resources/PrototypeProvider'
import SideBar from '../components/SideBar.vue'
import ItemBox from '../components/ItemBox.vue'
import Example from '../components/Example.vue'
import { ExportToCsv } from 'export-to-csv'
import FabricsProvider from '@/resources/FabricsProvider'
import ConvertFabricLabelToText from '@/assets/js/ConvertFabricLabelToText'

const PrototypeService = new PrototypeProvider()
const fileReader = new FileReader()

export default {
  components: {
    SideBar,
    ItemBox,
    Example
  },
  data () {
    return {
      fabricService: new FabricsProvider(),
      importing: false,
      gettingPrototype: false,
      selectedPrototype: [],
      prototypes: [],
      selectedFile: null,
      previewEnabled: false,
      currentImgPreview: '',
      dialogImport: false,
      csvValidateErrors: [],
      prototypeNotFounds: [],
      masterHeaderCsv: [
        'sketchid',
        'qty',
        'color'
      ],
      exporting: false,
      products: [],
      dialogFabric: false,
      exampleFabric: {},
      prototypeNotRequires: []
    }
  },
  computed: {
    ...mapGetters({
      store: 'Store/store'
    }),
    hasFabrics () {
      return this.selectedPrototype.filter((fb) => fb.fabrics.length && !fb.incomplete)
    },
    noFabrics () {
      return this.selectedPrototype.filter((fb) => !fb.fabrics.length || fb.incomplete)
    }
  },
  async mounted () {
    await this.getPrototypes()
  },
  methods: {
    ...mapActions({
      setErrorPage: 'Components/setErrorPage',
      setSnackbar: 'Components/setSnackbar'
    }),
    mappingPrototype (prototype) {
        let imageUrl = ''

        if (prototype?.order?.fitting && prototype?.order?.fitting?.[0]?.images?.[0]) {
          imageUrl = prototype?.order?.fitting?.[0]?.images?.[0]
        }

        let results = []
        results = prototype?.order?.colors.map(({ color, fabrics }) => {
          const fabric = fabrics
            .filter((sketchFabric) => sketchFabric.printInFabricLabel === true || typeof sketchFabric.printInFabricLabel !== 'boolean')
            .map(({ compositions, garmentPart, id, fabricNo, printInFabricLabel }) => {
                const productColorIndex = prototype.products.findIndex((pd) => pd.colors[0] === color)
                if (productColorIndex !== -1 && prototype.products[productColorIndex]?.photoUrls?.length) {
                  imageUrl = prototype.products[productColorIndex].photoUrls[0]
                }
                if (!garmentPart) return null
                return {
                  garmentPart,
                  compositions,
                  id,
                  fabricNo,
                  printInFabricLabel
                }
              }) || []
          return {
            id: prototype?.id,
            sketchId: prototype?.sketch.sketchId,
            imageUrl,
            color,
            fabrics: fabric.filter((f) => f),
            requirePrintFabricLabel: prototype.requirePrintFabricLabel
          }
        }) || []
        return results
    },
    async getPrototypes (search = '') {
      if (this.gettingPrototype) {
        return
      }
      try {
        this.gettingPrototype = true
        const { data } = await PrototypeService.getManyPrototypeHasProduct({ search })
        this.prototypes = data.flatMap((prototype) => this.mappingPrototype(prototype))
      } catch (error) {
        this.setErrorPage(error.sketchid)
      } finally {
        this.gettingPrototype = false
      }
    },
    addAmount (index) {
      this.selectedPrototype[index].qty++
    },
    removeAmount (index) {
      if (this.selectedPrototype[index].qty > 1) {
        this.selectedPrototype[index].qty--
      }
    },
    isNumberString (str) {
      return /^\d+$/.test(str)
    },
    isMonthYearString (str) {
      const regex = /^(0[1-9]|1[0-2])-\d{4}$/
      return regex.test(str)
    },
    onCloseCsvDialog () {
      this.dialogImport = false
      this.clearValidate()
    },
    clearValidate () {
      this.selectedFile = null
      this.csvValidateErrors = []
    },
    areArraysEqual (arr1, arr2) {
      if (arr1.length !== arr2.length) return false
      const sorted1 = [...arr1].sort()
      const sorted2 = [...arr2].sort()
      return sorted1.every((val, index) => val === sorted2[index])
    },
    findDuplicates (arr) {
      return arr.filter((item, index) => arr.indexOf(item) !== index)
    },
    async addPrototypeToSelected (prototype, qty = 1) {
      const duplicateIndex = this.prototypeNotRequires.findIndex((p) => p.sketchId === prototype.sketchId && p.color === prototype.color)
      if (prototype.requirePrintFabricLabel === false) {
        if (duplicateIndex === -1) {
          this.prototypeNotRequires.push(prototype)
        }
        return
      }
      const _prototype = { ...prototype }
      const duplicated = this.selectedPrototype.findIndex((selected) => (
        selected.sketchId === _prototype.sketchId
        && selected.color === _prototype.color
      ))
      if (duplicated === -1) {
        let incomplete = false
        await Promise.all(
          _prototype.fabrics
            .filter((sketchFabric) => sketchFabric.printInFabricLabel === true || typeof sketchFabric.printInFabricLabel !== 'boolean')
            .map(async (fabric, fabricIndex) => {
              const { data } = await this.fabricService.getByIdAllStatus(fabric.id)
              const compositions = data.compositions || []
              _prototype.fabrics[fabricIndex].compositions = compositions
              if (!compositions.length) incomplete = true
            })
        )
        this.selectedPrototype.push({ ..._prototype, incomplete, qty: Number(qty) })
      } else {
        this.selectedPrototype[duplicated].qty++
      }
    },
    removeItem (sketchId, color) {
      const removeIndex = this.selectedPrototype.findIndex((pt) => pt.color === color && pt.sketchId === sketchId)
      this.selectedPrototype.splice(removeIndex, 1)
      if (!this.selectedPrototype.length) this.clearValidate()
    },
    validateCsv () {
      this.csvValidateErrors = []
      if (!this.selectedFile) return
      fileReader.readAsText(this.selectedFile, 'utf8')
      fileReader.onload = async (readerEvent) => {
        try {
          const contents = readerEvent.target.result.split('\n')
          const elements = []
          contents.forEach((line) => {
            if (line.trim().length > 0) {
              const text = line
                .replaceAll('"', '')
                .replaceAll('\r', '')
                .split(',')
              if (!text.every((col) => col.trim() === '')) {
                elements.push(text)
              }
            }
          })
          if (!elements || !Array.isArray(elements) || !elements.length || elements.length === 1) {
            this.csvValidateErrors.push('The CSV contains no content. Please ensure the file has valid data.')
            return
          }

          const headerFields = elements[0].filter((h) => h)

          // คอลัมน์ไม่เกินแต่ field ไม่ถูก
          if (!this.areArraysEqual(this.masterHeaderCsv, headerFields)) {
            // เกินหาว่าอะไรเกิน
            const extraHeaders = headerFields.filter((h) => !this.masterHeaderCsv.includes(h))
            if (extraHeaders.length) {
              this.csvValidateErrors.push(
                `Header : The CSV contains more header fields than required: ${extraHeaders.join(', ')}. Please remove the extra fields`
              )
            }

            // ขาดหาว่าอะไรขาด
            const missingHeaders = this.masterHeaderCsv.filter((h) => !headerFields.includes(h))
            if (missingHeaders.length) {
              this.csvValidateErrors.push(`Header : Required headers are missing: ${missingHeaders.join(', ')}. Please add them.`)
            }

            // หาว่าอะไรซ้ำ
            const duplicateField = this.findDuplicates(headerFields)
            if (duplicateField.length) {
              this.csvValidateErrors.push(`Header : ${duplicateField.join(', ')} fields are duplicated`)
            }
            return
          }

          const addRowText = (existingText, newText) => `${existingText ? ', ' : ''} ${newText}`
          for (const [index, element] of elements.entries()) {
            if (index !== 0) {
              const productInfo = Object.fromEntries(headerFields.map((key, mapIndex) => [key, element[mapIndex]]))
              let rowFailMsg = ''
              if (!productInfo['qty'] || !this.isNumberString(productInfo['qty']) || (Number(productInfo['qty']) <= 0)) {
                rowFailMsg += addRowText(rowFailMsg, 'qty')
              }
              if (!productInfo['color']) rowFailMsg += addRowText(rowFailMsg, 'color')
              if (!productInfo['sketchid']) rowFailMsg += addRowText(rowFailMsg, 'sketchid')
              if (rowFailMsg) {
                rowFailMsg = `Row ${index + 1} : ${rowFailMsg} must be a valid \n`
                this.csvValidateErrors.push(rowFailMsg)
              }
            }
          }
        } catch (e) {
          this.csvValidateErrors.push('Something wrong on CSV validate')
        }
      }
    },
    async addProductFromCsv () {
      this.importing = true
      if (!this.selectedFile) {
        this.setSnackbar({
          value: true,
          message: 'กรุณาเลือกไฟล์',
          type: 'error',
          timeout: 6000
        })
        this.importing = false
        return
      }
      try {
        this.selectedPrototype = []
        this.prototypeNotFounds = []
        const prototypeFromCsv = []
        const dataFromCsv = []
        await new Promise((resolve, reject) => {
          fileReader.readAsText(this.selectedFile, 'utf8')
          fileReader.onload = async (readerEvent) => {
            const contents = readerEvent.target.result.split('\n')
            contents.forEach((line) => {
              if (line.trim().length > 0) {
                const text = line
                  .replaceAll('"', '')
                  .replaceAll('\r', '')
                  .split(',')
                if (!text.every((col) => col.trim() === '')) {
                  dataFromCsv.push(text)
                }
              }
            })
            const csvHeaderAsArray = dataFromCsv[0]
            for (const [index, prototypeAsArray] of dataFromCsv.entries()) {
              if (index !== 0) {
                const skuInfo = Object.fromEntries(csvHeaderAsArray.map((key, mapIndex) => [key, prototypeAsArray[mapIndex]]))
                prototypeFromCsv.push(skuInfo)
              }
            }
            await Promise.all(
              prototypeFromCsv.map(async (pt) => {
                const cleanSketchId = pt.sketchid.split('.')[0]
                const { data: prototypeLists } = await PrototypeService.getManyPrototypeHasProduct({ search: cleanSketchId })
                const prototypeData = prototypeLists[0] || null
                if (prototypeData) {
                  const isExistingColor = this.mappingPrototype(prototypeData).find(
                    (prototypeColor) => pt.color.toLowerCase() === prototypeColor.color
                  )
                  if (isExistingColor) {
                    this.addPrototypeToSelected(isExistingColor, pt.qty)
                  } else {
                    this.prototypeNotFounds.push({ ...pt, sketchid: pt.sketchid })
                  }
                } else {
                  this.prototypeNotFounds.push(pt)
                }
                return 'done'
              })
            )
          }
          resolve()
          fileReader.onerror = reject
        })
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: 'ไฟล์ไม่สามารถใช้งานได้กรุณาตรวจสอบ',
          type: 'error',
          timeout: 6000
        })
      } finally {
        this.importing = false
      }
      this.dialogImport = false
      this.selectedFile = null
    },
    showExample ({ fabrics, sketchId, color }) {
      this.dialogFabric = true
      this.exampleFabric = { fabrics, sketchId, color }
    },
    exportCsv () {
      this.exporting = true
      const results = []
      this.hasFabrics.forEach((prototype) => {
        const fabrics = prototype.fabrics.filter((fb) => fb.printInFabricLabel === true || typeof fb.printInFabricLabel !== 'boolean')
        const { labels } = new ConvertFabricLabelToText(fabrics, 11)
        if (labels) {
          for (let index = 0; index < prototype.qty; index++) {
            results.push({ sketchId: prototype.sketchId, color: prototype.color, text: labels })
          }
        }
      })
      const timeStringFormat = this.$dayjs().format('DD_MM_YYYY_HHmm')
      const options = {
        filename: `fabric_label_${timeStringFormat}`,
        showLabels: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(results)
      this.exporting = false
    },
    exportNoFabric () {
      const exportItem = this.noFabrics.map(({ sketchId, imageUrl, color, fabrics, id }) => {
        const url = `${window.location.origin}/prototype/order/edit/${id}`
        return {
          sketchId,
          imageUrl,
          color,
          fabric: fabrics.length
            ? fabrics.filter((fb) => !fb.compositions.length).map((fb) => fb.fabricNo).join(', ')
            : 'กรุณาตรวจสอบข้อมูล fabric ใน prototype',
          url
        }
      })
      const timeStringFormat = this.$dayjs().format('DD_MM_YYYY_HHmm')
      const options = {
        filename: `no_fabric_label_${timeStringFormat}`,
        showLabels: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(exportItem)
      this.exporting = false
    },
    downloadCsvTemplate () {
      const headers = ['sketchid', 'color', 'qty']
      const values = ['GW1111', 'red', '1']
      const csvContent = [headers, values].map((e) => e.join(',')).join('\n')

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', 'fabric_label_template.csv')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    removePrototypeNotRequire (index) {
      this.prototypeNotRequires.splice(index, 1)
    }
  }
}
</script>

<style>
</style>
